import { helper } from '@ember/component/helper';

import { latLngCollection } from 'rise-ui/utils/lat-lng-collection.js';

export default helper(function latLngCollectionHelper([ coordinates ]) {
  return latLngCollection(coordinates);
});
